var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { id: "cost-detail" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit($event)
        }
      }
    },
    [
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th"),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Personal")))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Corporate")))]),
            _vm._v(" "),
            _c("th")
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Breakfast")))]),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.model.PerrsonalCost.BreakfastCount,
                    expression: "model.PerrsonalCost.BreakfastCount",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "k-textbox",
                attrs: { readonly: _vm.readonly, type: "number", min: "0" },
                domProps: { value: _vm.model.PerrsonalCost.BreakfastCount },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.model.PerrsonalCost,
                      "BreakfastCount",
                      _vm._n($event.target.value)
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.model.CorporateFacility.BreakfastCount,
                    expression: "model.CorporateFacility.BreakfastCount",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "k-textbox",
                attrs: { readonly: _vm.readonly, type: "number", min: "0" },
                domProps: { value: _vm.model.CorporateFacility.BreakfastCount },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.model.CorporateFacility,
                      "BreakfastCount",
                      _vm._n($event.target.value)
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Count")))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Lunch")))]),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.model.PerrsonalCost.LunchCount,
                    expression: "model.PerrsonalCost.LunchCount",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "k-textbox",
                attrs: { readonly: _vm.readonly, type: "number", min: "0" },
                domProps: { value: _vm.model.PerrsonalCost.LunchCount },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.model.PerrsonalCost,
                      "LunchCount",
                      _vm._n($event.target.value)
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.model.CorporateFacility.LunchCount,
                    expression: "model.CorporateFacility.LunchCount",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "k-textbox",
                attrs: { readonly: _vm.readonly, type: "number", min: "0" },
                domProps: { value: _vm.model.CorporateFacility.LunchCount },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.model.CorporateFacility,
                      "LunchCount",
                      _vm._n($event.target.value)
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Count")))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Dinner")))]),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.model.PerrsonalCost.DinnerCount,
                    expression: "model.PerrsonalCost.DinnerCount",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "k-textbox",
                attrs: { readonly: _vm.readonly, type: "number", min: "0" },
                domProps: { value: _vm.model.PerrsonalCost.DinnerCount },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.model.PerrsonalCost,
                      "DinnerCount",
                      _vm._n($event.target.value)
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.model.CorporateFacility.DinnerCount,
                    expression: "model.CorporateFacility.DinnerCount",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "k-textbox",
                attrs: { readonly: _vm.readonly, type: "number", min: "0" },
                domProps: { value: _vm.model.CorporateFacility.DinnerCount },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.model.CorporateFacility,
                      "DinnerCount",
                      _vm._n($event.target.value)
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Count")))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Hotel")))]),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.model.PerrsonalCost.HotelCount,
                    expression: "model.PerrsonalCost.HotelCount",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "k-textbox",
                attrs: { readonly: _vm.readonly, type: "number", min: "0" },
                domProps: { value: _vm.model.PerrsonalCost.HotelCount },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.model.PerrsonalCost,
                      "HotelCount",
                      _vm._n($event.target.value)
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.model.CorporateFacility.HotelCount,
                    expression: "model.CorporateFacility.HotelCount",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "k-textbox",
                attrs: { readonly: _vm.readonly, type: "number", min: "0" },
                domProps: { value: _vm.model.CorporateFacility.HotelCount },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.model.CorporateFacility,
                      "HotelCount",
                      _vm._n($event.target.value)
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Count")))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Guesthouse")))]),
            _vm._v(" "),
            _c("td"),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.model.CorporateFacility.GuesthouseCount,
                    expression: "model.CorporateFacility.GuesthouseCount",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "k-textbox",
                attrs: { readonly: _vm.readonly, type: "number", min: "0" },
                domProps: {
                  value: _vm.model.CorporateFacility.GuesthouseCount
                },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.model.CorporateFacility,
                      "GuesthouseCount",
                      _vm._n($event.target.value)
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Count")))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Caravan")))]),
            _vm._v(" "),
            _c("td"),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.model.CorporateFacility.CaravanCount,
                    expression: "model.CorporateFacility.CaravanCount",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "k-textbox",
                attrs: { readonly: _vm.readonly, type: "number", min: "0" },
                domProps: { value: _vm.model.CorporateFacility.CaravanCount },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.model.CorporateFacility,
                      "CaravanCount",
                      _vm._n($event.target.value)
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Count")))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Tent")))]),
            _vm._v(" "),
            _c("td"),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.model.CorporateFacility.TentCount,
                    expression: "model.CorporateFacility.TentCount",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "k-textbox",
                attrs: { readonly: _vm.readonly, type: "number", min: "0" },
                domProps: { value: _vm.model.CorporateFacility.TentCount },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.model.CorporateFacility,
                      "TentCount",
                      _vm._n($event.target.value)
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Count")))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm.showTransport
        ? _c("table", [
            _c("thead", [
              _c("tr", [
                _c("th"),
                _vm._v(" "),
                _c("th", [
                  _vm._v(_vm._s(_vm.$CaptionsLibrary.get("Personal")))
                ]),
                _vm._v(" "),
                _c("th")
              ])
            ]),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", [
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.$CaptionsLibrary.get("IntownCostsInSource"))
                  )
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("sv-moneyinput", {
                      staticClass: "k-textbox",
                      attrs: { readonly: _vm.readonly, min: "0" },
                      model: {
                        value: _vm.model.PerrsonalCost.IntownCostsInSource,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.model.PerrsonalCost,
                            "IntownCostsInSource",
                            _vm._n($$v)
                          )
                        },
                        expression: "model.PerrsonalCost.IntownCostsInSource"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Amount")))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.$CaptionsLibrary.get("IntownCostsInDestination"))
                  )
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("sv-moneyinput", {
                      staticClass: "k-textbox",
                      attrs: { readonly: _vm.readonly, min: "0" },
                      model: {
                        value: _vm.model.PerrsonalCost.IntownCostsInDestination,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.model.PerrsonalCost,
                            "IntownCostsInDestination",
                            _vm._n($$v)
                          )
                        },
                        expression:
                          "model.PerrsonalCost.IntownCostsInDestination"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Amount")))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.$CaptionsLibrary.get("DailyCostsTransportation"))
                  )
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("sv-moneyinput", {
                      staticClass: "k-textbox",
                      attrs: { readonly: _vm.readonly, min: "0" },
                      model: {
                        value: _vm.model.PerrsonalCost.DailyCostsTransportation,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.model.PerrsonalCost,
                            "DailyCostsTransportation",
                            _vm._n($$v)
                          )
                        },
                        expression:
                          "model.PerrsonalCost.DailyCostsTransportation"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Amount")))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Plane")))]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("sv-moneyinput", {
                      staticClass: "k-textbox",
                      attrs: { readonly: _vm.readonly, min: "0" },
                      model: {
                        value: _vm.model.PerrsonalCost.IntercityCostsByPlane,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.model.PerrsonalCost,
                            "IntercityCostsByPlane",
                            _vm._n($$v)
                          )
                        },
                        expression: "model.PerrsonalCost.IntercityCostsByPlane"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Amount")))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Train")))]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("sv-moneyinput", {
                      staticClass: "k-textbox",
                      attrs: { readonly: _vm.readonly, min: "0" },
                      model: {
                        value: _vm.model.PerrsonalCost.IntercityCostsByTrain,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.model.PerrsonalCost,
                            "IntercityCostsByTrain",
                            _vm._n($$v)
                          )
                        },
                        expression: "model.PerrsonalCost.IntercityCostsByTrain"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Amount")))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Bus")))]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("sv-moneyinput", {
                      staticClass: "k-textbox",
                      attrs: { readonly: _vm.readonly, min: "0" },
                      model: {
                        value: _vm.model.PerrsonalCost.IntercityCostsByBus,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.model.PerrsonalCost,
                            "IntercityCostsByBus",
                            _vm._n($$v)
                          )
                        },
                        expression: "model.PerrsonalCost.IntercityCostsByBus"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Amount")))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Car")))]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("sv-moneyinput", {
                      staticClass: "k-textbox",
                      attrs: { readonly: _vm.readonly, min: "0" },
                      model: {
                        value: _vm.model.PerrsonalCost.IntercityCostsByCar,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.model.PerrsonalCost,
                            "IntercityCostsByCar",
                            _vm._n($$v)
                          )
                        },
                        expression: "model.PerrsonalCost.IntercityCostsByCar"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.$CaptionsLibrary.get("Amount")))])
              ])
            ])
          ])
        : _c("table", [
            _c("thead", [
              _c("tr", [
                _c("th"),
                _vm._v(" "),
                _c("th", [
                  _vm._v(_vm._s(_vm.$CaptionsLibrary.get("Corporate")))
                ]),
                _vm._v(" "),
                _c("th")
              ])
            ]),
            _vm._v(" "),
            _c("tbody", [
              !_vm.showTransport && _vm.model.klaimSystemTypeEmployeeTypeIds
                ? _c("tr", { staticStyle: { height: "35px" } }, [
                    _c("th", [
                      _vm._v(_vm._s(_vm.$CaptionsLibrary.get("DriverName")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        !_vm.readonly
                          ? _c("kendo-dropdownlist", {
                              staticClass: "width-70",
                              attrs: {
                                id: "model.DriverList.Id",
                                name: "EmployeeId",
                                "data-source": _vm.model.DriverList,
                                "data-text-field": "FullName",
                                "data-value-field": "Id",
                                filter: "contains",
                                "option-label": "انتخاب کنید"
                              },
                              on: { change: _vm.driverChange },
                              model: {
                                value: _vm.model.CorporateFacility.EmployeeId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.model.CorporateFacility,
                                    "EmployeeId",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "model.CorporateFacility.EmployeeId"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.readonly
                          ? _c("kendo-dropdownlist", {
                              staticClass: "width-70 ",
                              attrs: {
                                id: "model.DriverList.Id",
                                name: "EmployeeId",
                                "data-source": _vm.model.DriverList,
                                "data-text-field": "FullName",
                                "data-value-field": "Id",
                                filter: "contains",
                                readonly: "true"
                              },
                              model: {
                                value: _vm.model.CorporateFacility.EmployeeId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.model.CorporateFacility,
                                    "EmployeeId",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "model.CorporateFacility.EmployeeId"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1)
            ])
          ]),
      _vm._v(" "),
      _c("fieldset", { staticClass: "whole-row" }, [
        _c("legend", [
          _vm._v(
            _vm._s(
              _vm.$MessagesLibrary.get("TheseItemsAreForOfficialEmployees")
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", [
            _vm._v(_vm._s(_vm.$CaptionsLibrary.get("ExtraTimeSpent")))
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.model.Other.ExtraTimeSpent,
                expression: "model.Other.ExtraTimeSpent",
                modifiers: { number: true }
              }
            ],
            staticClass: "k-textbox",
            attrs: { readonly: _vm.readonly, type: "number", min: "0" },
            domProps: { value: _vm.model.Other.ExtraTimeSpent },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.model.Other,
                  "ExtraTimeSpent",
                  _vm._n($event.target.value)
                )
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", [
            _vm._v(_vm._s(_vm.$CaptionsLibrary.get("AghmariDuration")))
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.model.Other.AghmariDuration,
                expression: "model.Other.AghmariDuration",
                modifiers: { number: true }
              }
            ],
            staticClass: "k-textbox",
            attrs: { readonly: _vm.readonly, type: "number", min: "0" },
            domProps: { value: _vm.model.Other.AghmariDuration },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.model.Other,
                  "AghmariDuration",
                  _vm._n($event.target.value)
                )
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", [
            _vm._v(_vm._s(_vm.$CaptionsLibrary.get("OffshorePlatformMission")))
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.model.Other.OffshorePlatformMission,
                expression: "model.Other.OffshorePlatformMission",
                modifiers: { number: true }
              }
            ],
            staticClass: "k-textbox",
            attrs: { readonly: _vm.readonly, type: "number", min: "0" },
            domProps: { value: _vm.model.Other.OffshorePlatformMission },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.model.Other,
                  "OffshorePlatformMission",
                  _vm._n($event.target.value)
                )
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$CaptionsLibrary.get("OtherCost")) +
                "- " +
                _vm._s(_vm.$CaptionsLibrary.get("InDay"))
            )
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.model.Other.OtherCost,
                expression: "model.Other.OtherCost",
                modifiers: { number: true }
              }
            ],
            staticClass: "k-textbox",
            attrs: { readonly: _vm.readonly, type: "number", min: "0" },
            domProps: { value: _vm.model.Other.OtherCost },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.model.Other,
                  "OtherCost",
                  _vm._n($event.target.value)
                )
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      !_vm.readonly
        ? _c(
            "div",
            { staticClass: "whole-row", staticStyle: { padding: "1em" } },
            [
              _c("button", { staticClass: "k-button k-primary" }, [
                _vm._v(_vm._s(_vm.$CaptionsLibrary.get("Confirm")))
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [_c("th"), _vm._v(" "), _c("td")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [_c("th"), _vm._v(" "), _c("td")])
  }
]
render._withStripped = true

export { render, staticRenderFns }